"use strict";
exports.__esModule = true;
exports.isEmpty = exports.isNumber = exports.isFloat = exports.isInt = exports.isString = exports.isFunction = exports.isObject = exports.isArray = exports.isSymbol = void 0;
var isSymbol = function (value) {
    return !!value && value.constructor === Symbol;
};
exports.isSymbol = isSymbol;
var isArray = function (value) {
    return !!value && value.constructor === Array;
};
exports.isArray = isArray;
var isObject = function (value) {
    return !!value && value.constructor === Object;
};
exports.isObject = isObject;
var isFunction = function (value) {
    return !!(value && value.constructor && value.call && value.apply);
};
exports.isFunction = isFunction;
var isString = function (value) {
    return typeof value === 'string' || value instanceof String;
};
exports.isString = isString;
var isInt = function (value) {
    return Number(value) === value && value % 1 === 0;
};
exports.isInt = isInt;
var isFloat = function (value) {
    return Number(value) === value && value % 1 !== 0;
};
exports.isFloat = isFloat;
var isNumber = function (value) {
    return Number(value) === value;
};
exports.isNumber = isNumber;
var isEmpty = function (value) {
    if (value === true)
        return true;
    if (value === false)
        return true;
    if ((0, exports.isNumber)(value))
        return true;
    if (value === null || value === undefined)
        return true;
    var length = value.length;
    if ((0, exports.isNumber)(length))
        return length === 0;
    var size = value.size;
    if ((0, exports.isNumber)(size))
        return size === 0;
    var keys = Object.keys(value).length;
    return keys === 0;
};
exports.isEmpty = isEmpty;
//# sourceMappingURL=typed.js.map